export default __webpack_public_path__ + "assets/chart.fdc22803.svg";